import React, { Fragment } from "react";
import { Link, withRouter } from "react-router-dom";
import moment from "moment";
import { Table, Form, Button } from "react-bootstrap";
import { withStyles } from "@material-ui/core/styles";
import { teal, red } from "@material-ui/core/colors";
import Switch from "@material-ui/core/Switch";
import axios from "axios";
import { API_ROOT } from "../utils/api-config";

const CustomSwitch = withStyles({
  switchBase: {
    color: red[300],
    "&$checked": {
      color: teal[500],
    },
    "&$checked + $track": {
      backgroundColor: teal[500],
    },
  },
  checked: {},
  track: {},
})(Switch);

class TimeslotsToday extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      visible: false,
      number_of_drivers: 1,
      active_confirm: false,
    };
    this.handleConfirm = this.handleConfirm.bind(this);
    this.toggleVisible = this.toggleVisible.bind(this);
    this.handleInputChange = this.handleInputChange.bind(this);
  }

  componentDidMount() {
    this.props;
  }

  toggleVisible() {
    this.setState((prevState) => ({
      visible: !prevState.visible,
    }));
  }

  handleInputChange(event) {
    const target = event.target;
    const value = target.value;
    const name = target.name;
    if (!/^[0-9]+$/.test(value)) {
      target.focus();
      return;
    } else
      this.setState({
        [name]: value,
        active_confirm: true,
      });
  }
  redirect = () => {
    this.props.history.push({
      pathname: `/timeslots/${this.props.timeslots[0].id}`,
    });
  };

  handleChange = (event, type) => {
    const name = event.target.name;
    const value = event.target.checked;
    this.props.handleSwitchSubmit(name, `booking[${type}]`, value);
  };

  handleConfirm(e) {
    e.preventDefault();
    this.props.handleDriversSubmit(this.state.number_of_drivers);
    this.toggleVisible();
  }
  render() {
    moment.locale("en-gb");
    const { timeslots } = this.props;
    return (
      <Fragment>
        <div className="container-fluid">
          <div className="d-flex flex-row justify-content-end">
            <div className="p-6">
              {!this.state.visible && (
                <Button
                  className="mb-10"
                  variant="outline-primary"
                  onClick={this.toggleVisible}
                >
                  Change Number of Drivers
                </Button>
              )}
              {this.state.visible && (
                <div className=" p-6">
                  <Form className="form-inline" onSubmit={this.handleConfirm}>
                    <Form.Row>
                      <Form.Group controlId="formNumDrivers">
                        <Form.Label>
                          <h4>
                            <span className="text-primary">Set New #</span>
                          </h4>
                        </Form.Label>
                        <Form.Control
                          className="mx-sm-3"
                          name="number_of_drivers"
                          onChange={this.handleInputChange}
                        />
                      </Form.Group>
                    </Form.Row>
                    <Button
                      className="ml-3"
                      variant="primary"
                      disabled={!this.state.active_confirm}
                      type="submit"
                    >
                      Confirm
                    </Button>
                  </Form>
                </div>
              )}
            </div>
          </div>
          <br></br>
          <Table striped bordered hover responsive>
            <thead>
              <tr className="table-primary">
                <th>Timeslot</th>
                <th>Drivers</th>
                <th>Neighborhood</th>
                <th>#/hr</th>
                <th>Booked</th>
                <th>Available</th>
                <th>Out Of Zone</th>
                <th>Special Only</th>
              </tr>
            </thead>
            <tbody>
              {timeslots.map((slot, i) => (
                <tr
                  key={timeslots[i].id}
                  className={
                    timeslots[i].id % 2 == 0 ? "table-info" : "table-primary"
                  }
                >
                  {/* {console.log(timeslots[i])} */}
                  <td>
                    <Link to={`/timeslots/${timeslots[i].id}`}>
                      {timeslots[i].delivery_window}
                    </Link>
                  </td>
                  <td>
                    <span className="badge badge-pill badge-sacha">
                      {timeslots[i].anchors.length} /{" "}
                      {timeslots[i].number_of_drivers}
                    </span>
                  </td>
                  <td>
                    {timeslots[i].anchors.map((fsa_id, index) => {
                      const fsa = this.props.fsas.find(
                        (neibor) => neibor.id === fsa_id
                      );
                      return (
                        <p key={`${i}${index}${fsa_id}`}>
                          <span className="badge badge-pill badge-alicia">
                            {fsa.fsa}
                          </span>{" "}
                          {fsa.neighborhood}
                          <br></br>
                        </p>
                      );
                    })}
                  </td>
                  <td>
                    <span className="badge badge-pill badge-riley">
                      {timeslots[i].deliveries_per_hour}
                    </span>
                  </td>
                  <td>
                    {timeslots[i].qty.map((qt, i) => {
                      return (
                        <p key={i}>
                          {timeslots[i] &&
                          qt < timeslots[i].deliveries_per_hour ? (
                            <span className="badge badge-pill badge-light">
                              {qt}
                            </span>
                          ) : (
                            <span className="badge badge-pill badge-dark">
                              {qt}
                            </span>
                          )}
                          <br></br>
                        </p>
                      );
                    })}
                  </td>
                  <td>
                    <CustomSwitch
                      checked={timeslots[i].available}
                      onChange={(e) => this.handleChange(e, "available")}
                      name={timeslots[i].id.toString()}
                      color="primary"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </td>
                  <td>
                    <CustomSwitch
                      checked={timeslots[i].out_of_zone_eligible}
                      onChange={(e) =>
                        this.handleChange(e, "out_of_zone_eligible")
                      }
                      name={timeslots[i].id.toString()}
                      color="primary"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </td>
                  <td>
                    <CustomSwitch
                      checked={timeslots[i].special_only}
                      onChange={(e) =>
                        this.handleChange(e, "special_only")
                      }
                      name={timeslots[i].id.toString()}
                      color="primary"
                      inputProps={{ "aria-label": "primary checkbox" }}
                    />
                  </td>
                </tr>
              ))}
            </tbody>
          </Table>

          <br></br>
        </div>
      </Fragment>
    );
  }
}

export default withRouter(TimeslotsToday);
